"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CDN_DOMAIN = exports.DEFAULT_PARAMS = exports.NOT_PROCESSED_EXTENSIONS = exports.MAX_OUTPUT_JPEG_IMAGE_DIMENSION = exports.MAX_OUTPUT_IMAGE_DIMENSION = void 0;
exports.MAX_OUTPUT_IMAGE_DIMENSION = 3000;
exports.MAX_OUTPUT_JPEG_IMAGE_DIMENSION = 5000;
exports.NOT_PROCESSED_EXTENSIONS = ['svg', 'gif'];
exports.DEFAULT_PARAMS = ['format/auto', 'stretch/off', 'progressive/yes'];
exports.DEFAULT_CDN_DOMAIN = 'ucarecdn.com';
